import Header from 'Components/Pages/PricingPlans/Header';
import FooterCard from 'Components/Pages/PricingPlans/FooterCard';
import PricingTable from 'Components/Pages/PricingPlans/PricingTable';
import React, { useState, useCallback, useEffect } from 'react';
import useFetchPlans from 'hooks/subscriptions/fetchPlans';
import Styles from './PlanDetailScreen.module.scss';

const PlanDetailsScreen = () => {
  const [isYearly, setIsYearly] = useState(true); // Changed from false to true to default to yearly
  const [subscriptionPlans, setSubscriptionPlans] = useState({});
  const [currentSubscription, setCurrentSubscription] = useState(null);
  const [lastSubscription, setLastSubscription] = useState(null);
  const fetchPlansData = useFetchPlans();

  const fetchPlans = useCallback(
    async (setShouldRedirect) => {
      fetchPlansData({
        setSubscriptionPlans,
        setCurrentSubscription,
        setLastSubscription,
        setShouldRedirect,
      });
    },
    [fetchPlansData],
  );

  useEffect(() => {
    fetchPlans();
  }, [fetchPlans]);

  // Mock data structure matching the actual data format from the subscription service
  const mockPlans = [
    {
      id: 'basic_plan',
      type: 'Basic Plan',
      amount: isYearly ? 13 : 19,
      old_amount: isYearly ? 19 : 19,
      interval: isYearly ? 'year' : 'month',
      services: [
        'AI-powered Topic Ideation',
        'AI-powered Content Planning',
        'Access to AI Templates',
        'Smart Entry Editor',
        'AI Editing Features',
      ],
    },
    {
      id: 'pro_plan',
      type: 'Pro Plan',
      amount: isYearly ? 45 : 65,
      old_amount: isYearly ? 65 : 65,
      interval: isYearly ? 'year' : 'month',
      services: [
        'Comes with 1 Seat (but can add up to 2 seats for $45/mo per seat)',
        'AI-powered projects with automated content planning',
        'SEO research tool',
        'Integration with up to 5 channels',
        'Brand Voice',
        'Direct scheduling and publishing to connected channels',
        'Multi-model prompting (Claude, GPT, Gemini) in smart entry editor',
        'Collaboration features',
      ],
    },
    {
      id: 'business_plan',
      type: 'Business Plan',
      amount: isYearly ? 139 : 199,
      old_amount: isYearly ? 199 : 199,
      interval: isYearly ? 'year' : 'month',
      services: [
        '5 user seats (additional seats available at $35/mo per seat)',
        'Review and approval workflow features',
        'Advanced analytics and reporting',
        'AI-powered content strategy',
      ],
    },
  ];

  // Create CTAs for each plan
  const ctas = mockPlans.map((plan) => (
    <FooterCard key={plan.id} type={plan.type}>
      <button
        className={`cancel_btn w-100 ${
          plan.type === 'Pro Plan'
            ? 'pro_btn'
            : plan.type === 'Business Plan'
              ? 'business_btn'
              : 'basic_btn'
        }`}
      >
        {plan.type === 'Business Plan'
          ? 'Start Your 3-Day Trial'
          : 'Start Your 3-Day Trial'}
      </button>
    </FooterCard>
  ));

  const handleToggleClick = () => {
    setIsYearly(!isYearly);
  };

  return (
    <div className={Styles.layout}>
      <div className={Styles.header}>
        <Header isChecked={isYearly} handleToggleClick={handleToggleClick} />
        <button className={Styles.close_btn}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M15 5L5 15M5 5L15 15"
              stroke="#344054"
              strokeWidth="1.67"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      <PricingTable
        plans={
          isYearly
            ? subscriptionPlans.annualplan
            : subscriptionPlans.monthlyPlan
        }
        duration={isYearly ? 'year' : 'month'}
        currentSubscription={currentSubscription}
        lastSubscription={lastSubscription}
        ctas={ctas}
      />
    </div>
  );
};

export default PlanDetailsScreen;
